module.exports = __webpack_public_path__ + "static/media/profile_example.0ae6de61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/profile_example.jpg
// module id = 2048
// module chunks = 0